const inp = "w-full rounded-xl border border-input bg-white px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#FF7A00]";
const pill = (on) => `rounded-full px-3.5 py-1.5 text-xs font-semibold border transition-colors ${on ? "bg-[#0B0B0B] border-[#0B0B0B] text-white" : "bg-white border-border text-[#575757] hover:border-[#FF7A00]"}`;

export const MarketingForm = ({ opts, sel, setSel }) => {
  const set = (k) => (e) => setSel({ ...sel, [k]: e.target.value });
  const camp = opts.campaigns.find((c) => c.key === sel.campaign);
  const product = opts.products.find((p) => p.slug === sel.slug);
  return (
    <div className="card-warm p-6 space-y-5" data-testid="mkt-form">
      <div>
        <label className="text-xs font-semibold text-[#8A8A8A]">1 · Producto</label>
        <select data-testid="mkt-product" className={`${inp} mt-1`} value={sel.slug} onChange={set("slug")}>
          {[["pf", "Personas"], ["pm", "Empresas"]].map(([seg, l]) => <optgroup key={seg} label={l}>{opts.products.filter((p) => p.seg === seg).map((p) => <option key={p.slug} value={p.slug}>{p.vertical_label} · {p.name}</option>)}</optgroup>)}
        </select>
        {product && <p className="text-xs text-[#575757] mt-1.5" data-testid="mkt-product-hook">{product.hook || product.tagline}</p>}
      </div>
      <div>
        <label className="text-xs font-semibold text-[#8A8A8A]">2 · Formato de imagen</label>
        <div className="flex flex-wrap gap-2 mt-1.5">{opts.formats.map((f) => <button key={f.key} type="button" data-testid={`mkt-format-${f.key}`} onClick={() => setSel({ ...sel, format: f.key })} className={pill(sel.format === f.key)}>{f.label}</button>)}</div>
      </div>
      <div>
        <label className="text-xs font-semibold text-[#8A8A8A]">3 · Campaña de temporada (opcional)</label>
        <select data-testid="mkt-campaign" className={`${inp} mt-1`} value={sel.campaign} onChange={set("campaign")}>
          <option value="">Sin campaña · mensaje del producto</option>
          {opts.campaigns.map((c) => <option key={c.key} value={c.key}>{c.name}{c.active ? " · en temporada" : ""}{(c.products || []).includes(sel.slug) ? " ★" : ""}</option>)}
        </select>
        {camp && <p className="text-xs text-[#575757] mt-1.5" data-testid="mkt-campaign-hint"><b>{camp.headline}</b> — {camp.sub}</p>}
      </div>
      <div>
        <label className="text-xs font-semibold text-[#8A8A8A]">4 · Tono de los textos IA</label>
        <div className="flex flex-wrap gap-2 mt-1.5">{opts.tones.map(([k, l]) => <button key={k} type="button" data-testid={`mkt-tone-${k}`} onClick={() => setSel({ ...sel, tone: k })} className={pill(sel.tone === k)}>{l}</button>)}</div>
      </div>
      <details className="rounded-xl border border-border bg-white p-3" data-testid="mkt-advanced">
        <summary className="text-xs font-semibold cursor-pointer text-[#575757]">Personalizar titular, subtítulo y WhatsApp</summary>
        <div className="mt-3 space-y-2">
          <input data-testid="mkt-headline" className={inp} placeholder={`Titular (por defecto: ${camp?.headline || product?.hero || ""})`} value={sel.headline} onChange={set("headline")} maxLength={120} />
          <input data-testid="mkt-sub" className={inp} placeholder={`Subtítulo (por defecto: ${camp?.sub || product?.tagline || ""})`} value={sel.sub} onChange={set("sub")} maxLength={160} />
          <input data-testid="mkt-phone" className={inp} placeholder="WhatsApp a mostrar (10 dígitos)" value={sel.phone} onChange={set("phone")} />
        </div>
      </details>
    </div>
  );
};
